export const IllustInquiryEmpty = ({ width = '100%' }: JSX.IntrinsicElements['svg']) => (
  <svg width={width} viewBox='0 0 375 140' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_3056_23873)'>
      <path
        d='M217.999 31.1855H156.758C152.34 31.1855 148.758 34.7673 148.758 39.1855V110.005C148.758 114.423 152.34 118.005 156.758 118.005H217.999C222.417 118.005 225.999 114.423 225.999 110.005V39.1855C225.999 34.7673 222.417 31.1855 217.999 31.1855Z'
        fill='url(#paint0_linear_3056_23873)'
      />
      <path
        d='M212.441 37.8755H162.316C158.45 37.8755 155.316 41.0095 155.316 44.8755V104.31C155.316 108.176 158.45 111.31 162.316 111.31H212.441C216.307 111.31 219.441 108.176 219.441 104.31V44.8755C219.441 41.0095 216.307 37.8755 212.441 37.8755Z'
        fill='#EEEEEE'
      />
      <path
        d='M207.466 62.3898C207.466 63.877 206.258 65.0827 204.768 65.0827H169.684C169.407 65.0827 169.125 65.0481 168.858 64.9591C167.684 64.5688 166.977 63.5163 166.977 62.3848C166.977 61.2533 167.684 60.2009 168.858 59.8105C169.125 59.7216 169.402 59.687 169.684 59.687H204.768C206.258 59.687 207.466 60.8926 207.466 62.3799V62.3898Z'
        fill='#DCDCDC'
      />
      <path
        d='M199.609 74.8932C199.609 76.3805 198.402 77.5861 196.912 77.5861H169.684C169.407 77.5861 169.125 77.5515 168.858 77.4625C167.684 77.0722 166.977 76.0198 166.977 74.8883C166.977 73.7567 167.684 72.7043 168.858 72.314C169.125 72.225 169.402 72.1904 169.684 72.1904H196.912C198.402 72.1904 199.609 73.396 199.609 74.8833V74.8932Z'
        fill='#DCDCDC'
      />
      <path
        d='M190.498 87.2589C190.498 88.7462 189.29 89.9518 187.8 89.9518H169.684C169.407 89.9518 169.125 89.9172 168.858 89.8283C167.684 89.4379 166.977 88.3855 166.977 87.254C166.977 86.1225 167.684 85.07 168.858 84.6797C169.125 84.5907 169.402 84.5562 169.684 84.5562H187.805C189.295 84.5562 190.503 85.7618 190.503 87.249L190.498 87.2589Z'
        fill='#DCDCDC'
      />
      <path
        d='M187.38 22.7275C184.416 22.7275 181.966 24.9419 181.551 27.8193H193.21C192.795 24.9374 190.344 22.7275 187.38 22.7275Z'
        fill='url(#paint1_linear_3056_23873)'
      />
      <path
        d='M193.965 27.5786H181.036H175.656C173.447 27.5786 171.656 29.3695 171.656 31.5786V38.5402C171.656 40.7493 173.447 42.5402 175.656 42.5402H199.345C201.554 42.5402 203.345 40.7493 203.345 38.5402V31.5786C203.345 29.3695 201.554 27.5786 199.345 27.5786H193.965Z'
        fill='url(#paint2_linear_3056_23873)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_3056_23873'
        x1='187.378'
        y1='31.1855'
        x2='187.378'
        y2='118.005'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#CCCCCC' />
        <stop offset='1' stopColor='#AAAAAA' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_3056_23873'
        x1='187.38'
        y1='29.957'
        x2='187.38'
        y2='13.5632'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#555555' />
        <stop offset='1' stopColor='#B6B6B6' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_3056_23873'
        x1='187.501'
        y1='44.4029'
        x2='187.501'
        y2='-3.62423'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#555555' />
        <stop offset='1' stopColor='#B6B6B6' />
      </linearGradient>
      <clipPath id='clip0_3056_23873'>
        <rect width='77' height='96' fill='white' transform='translate(149 22)' />
      </clipPath>
    </defs>
  </svg>
);
